//是否已登录
const isLogin = state => state.isLogin
//菜单列表
const menuList = state => state.menuList
//应用列表
const appList = state => state.appList
//用户信息
const userInfo = state => state.userInfo
//系统列表
const projectList = state => state.projectList
//系统id
const projectId = state => state.projectId
//全部类别
const categoryList = state => state.categoryList
//按钮权限
const businessMenuIdList = state => state.businessMenuIdList || []

export default {
    isLogin,
    menuList,
    appList,
    userInfo,
    projectList,
    projectId,
    categoryList,
    businessMenuIdList
}